module.exports = __webpack_public_path__ + "img/current-calendar-icon.fc28bad6.svg";